// CKEditor locales are loaded dynamically by RichTextInput.vue on mount

// Vuetify locale support
import en from 'vuetify/lib/locale/en.mjs';
import es from 'vuetify/lib/locale/es.mjs';
import pt from 'vuetify/lib/locale/pt.mjs';
import fr from 'vuetify/lib/locale/fr.mjs';

// Set default locale so working with Weekdays does not break for different locales
import { Settings as LuxonSettings } from 'luxon';
LuxonSettings.defaultLocale = 'en';

export const vuetifyLocales = {
  en, // Vuetify has English by default
  es,
  'es-mx': es,
  pt,
  'pt-br': pt,
  fr,
  'fr-ca': fr
};
